export var views = {
  news: 'news',
  offers: 'offers'
};
export var imgPositions = {
  top: 'top',
  left: 'left',
  right: 'right',
  full: 'full'
};